import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import LogRocket from 'logrocket';

LogRocket.init('t4souq/marexhcc');

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
